import { TableView } from "@covertree/ui/table/TableView";
import { useGetResidents } from "@redux/residents/hooks/useGetResidents";
import { SortOrder } from "@graphql/api";

export default function ResidentsTable() {
  const {
    loading,
    error,
    residents,
    columns,
    filters,
    sortBy,
    order,
    totalCount,
    rowsPerPage,
    currentPage,
    handleChangePage,
    handleFilterChange,
    handleSortChange,
    handleRowsPerPageChange,
  } = useGetResidents();

  return (
    <TableView
      header="Residents"
      loading={loading}
      error={error}
      tabs={filters}
      totalCount={totalCount}
      page={currentPage}
      rows={residents}
      rowsPerPage={rowsPerPage}
      sortBy={sortBy}
      sortOrder={order === SortOrder.Ascending ? "asc" : "desc"}
      columns={columns}
      onTabChange={handleFilterChange}
      onPageChange={handleChangePage}
      onSortChange={handleSortChange}
      onRowsPerPageChange={handleRowsPerPageChange}
    />
  );
}
